/**
 * The Version of the application
 *
 * @type {string}
 */
export const APP_VERSION = process.env.VUE_APP_VERSION

/**
 * The API Host to connect to
 *
 * @type {string}
 */
export const API_HOST = process.env.VUE_APP_SCP_API_HOST
